<template>
	<el-row id="TheRegister" type="flex" justify="center">
		<el-col class="loginBox"> 
			<CloseIcon/>
			<el-form ref="userForm" :model="userForm" status-icon label-width="80px" class="demo-ruleForm" :rules="rules">
				<div class="titleIcon"><img src="../pic/titleIcon.png" /></div>
				<div class="title">请预订注册</div>
				<el-form-item label="活动名称" prop="activityName">
					<el-input v-model="userForm.activityName" placeholder="请输入活动名称!" type="text"></el-input>
				</el-form-item>
				<el-form-item label="主办方" prop="activityHolder">
					<el-input v-model="userForm.activityHolder" placeholder="请输入主办方!" type="text"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contacts">
					<el-input v-model="userForm.contacts" placeholder="请输入联系人!" type="text"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="mobile">
					<el-input v-model="userForm.mobile" placeholder="请输入手机号!" maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="verificateCode" style="position: relative;">
					<el-col :span="18">
						<el-input v-model="userForm.verificateCode" placeholder="验证码"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button style="width: 100%;background: #B7A575;border-color:#B7A575 ;" type="primary" @click="getCode">获取证码</el-button>
					</el-col>
				</el-form-item>
				<el-form-item label="活动日期" prop="playTime" style="position: relative;">
					<el-date-picker v-model="userForm.playTime" value-format="yyyy-MM-dd" style="width:100%;" type="datetime"
					 placeholder="活动日期">
					</el-date-picker>
				</el-form-item>
<!-- 				<el-form-item label="活动类型" prop="activityType">
					<el-select v-model="userForm.activityType">
						<el-option v-for="item in ActiveTypeSelectForm" :key="item.id" :label="item.name" :value="item.selectId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="邮件" prop="email">
					<el-input v-model="userForm.email" placeholder="请输入邮件!"></el-input>
				</el-form-item> -->
				<el-form-item label="密码" prop="password">
					<el-input type="password" v-model="userForm.password" maxlength="6"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPass">
					<el-input type="password" v-model="userForm.checkPass" maxlength="6"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button style="width: 100%;background: #B7A575;border-color:#B7A575 ;" type="primary" @click="submitForm('userForm')">确认</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<FooterMes/>
	</el-row>
</template>
<!--数据存贮交互，事件控制地区-->
<script>
	import FooterMes from "@/components/FooterMes.vue"; // 底部版权说明
	import CloseIcon from "@/components/CloseIcon"; // 关闭图标
	export default {
		name: 'TheRegister',
		components: {
			FooterMes, //底部版权说明
			CloseIcon, //关闭图标
		},
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.userForm.checkPass !== '') {
						this.$refs.userForm.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.userForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				globalHttpUrl: this.httpUrl,
				FooterMesColor: "#000",
				userForm: {
					'activityName': '', //活动名称
					'activityHolder': '', //主办方
					'contacts': '', //联系人
					'mobile': '', //手机号
					'verificateCode': '', //验证码
					'playTime': '', //开始日期
					'email': '', //邮箱
					'password': '', //密码
					'checkPass': '', //密码
					'activityType': '', //密码
				},
				ActiveTypeSFplaceholder: "请选择！",
				//表单验证
				rules: {
					activityName: [{
						required: true,
						message: '请输入活动名称！',
						trigger: 'blur'
					}],
					activityHolder: [{
						required: true,
						message: '请输入主办方！',
						trigger: 'blur'
					}],
					contacts: [{
						required: true,
						message: '请输入联系人！',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请输入手机号！',
						trigger: 'blur'
					}],
					verificateCode: [{
						required: true,
						message: '请输入验证码！',
						trigger: 'blur'
					}],
					playTime: [{
						required: true,
						message: '请输入起始时间！',
						trigger: 'blur'
					}],
					//密码验证
					password: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}, {
						min: 6,
						max: 6,
						message: '请输入6位密码！',
						trigger: 'blur'
					}],
					//再次密码验证
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}, {
						min: 6,
						max: 6,
						message: '位密码',
						trigger: 'blur'
					}], //密码验证
				}
			}
		},
		methods: {
			submitForm: function(submitForm) {
				const that = this;
				this.$refs[submitForm].validate((valid) => {
					if (valid) { 
						const sendData = that.userForm ;
						sendData.userType="0";
						const sendUrl = this.httpUrl + "HXXCStadiumPCService/stadium/addStadiumUser";
						that.axiosPost(sendUrl, sendData).then((res) => {
							const backData = res.data;
							if (parseInt(backData.state)  == 0) {
								that.$message({
									message: "注册成功！",
									type: 'success',
									onClose: () => {
										that.$router.push({
											path: '/',
										});
									}
								});
							} else {
								that.$message({
									message: backData.message,
									type: 'warning'
								});
							}
						})
					}
				})
			},
			getCode(){
				const sendUrl =this.appHttpUrl+"HXXCServiceWeChat/sms/stadiumSend?mobile="+this.userForm.mobile;
				const sendData={};
				this.axiosGet(sendUrl, sendData).then((response) => {
				       console.log(response);
				}).catch((erroe)=>{
					console.log(erroe);
				})
			}
			
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#TheRegister {
		width: 100%;
		height: 100%;
		background: url(../pic/loginBg.jpg) no-repeat;
		background-size: 100% 100%;
	}

	.loginBox {
		width: 33%;
		background: #fff;
		padding: 34px;
		border-radius: 4px;
		margin-top:100px;
		margin-bottom:100px;
		position: relative;
	}

	.demo-ruleForm {
		width: 100%;
	}

	.el-input__icon {
		position: absolute;
		right: 5px;
		top: 0;
	}

	.fontMes {
		width: 100%;
		text-align: right;
		color: #B7A575;
		font-size: 8px;
		margin-top: -11px;
		margin-bottom: 11px;

	}

	.title {
		color: #000000;
		font-weight: bold;
		font-size: 24px;
		margin-bottom: 29px;
		text-align: center;
	}

	.titleIcon {
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/views/TheRegister.vue